import React from 'react';

import PageStore from './stores/PageStore';
import PaginationLinks from './components/PaginationLinks';

const MuiPagination = function MuiPagination(props) {
  const pageData = new PageStore(props);

  return (
    <>
      <PaginationLinks pageData={pageData} />
    </>
  );
};

export default MuiPagination;
